import React from 'react'
import { Redirect } from '@reach/router'

import SEO from '@/components/seo'

export default () => (
  <>
    <SEO title="GIPHY Developers" />
    <Redirect to="/docs/sdk" noThrow />
  </>
)
